import { render, staticRenderFns } from "./ScanEmballageOverview.vue?vue&type=template&id=18532e66&scoped=true&"
import script from "./ScanEmballageOverview.vue?vue&type=script&lang=ts&"
export * from "./ScanEmballageOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ScanEmballageOverview.vue?vue&type=style&index=0&id=18532e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18532e66",
  null
  
)

export default component.exports